import { FieldStyles } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
export const styles = css `
  ${FieldStyles}
`;
//# sourceMappingURL=field.styles.js.map